import { render, staticRenderFns } from "./supplier-list.view.vue?vue&type=template&id=41c49a05"
import script from "./supplier-list.view.vue?vue&type=script&lang=js"
export * from "./supplier-list.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports